import { say } from "../../localization/say.ts";
import { calledBy } from "../../me/called.ts";

export type Somebody = { account: string; handle: string; displayName: string | null };

export const NAMES_BEFORE_A_COUNT = 2;

export function chosenTitle(title: string | null | undefined): string | null {
  const trimmed = title?.trim();
  return trimmed ? trimmed : null;
}

export function derivedTitle(people: readonly Somebody[], me: string): string {
  const others = [...people]
    .filter((one) => one.account !== me)
    .sort((first, second) => first.handle.localeCompare(second.handle))
    .map((one) => calledBy(one) ?? one.handle);
  if (others.length === 0) return "";
  if (others.length <= NAMES_BEFORE_A_COUNT) return others.join(say("title.and"));
  const named = others.slice(0, NAMES_BEFORE_A_COUNT).join(say("title.and"));
  return say("title.andOthers")(named, others.length - NAMES_BEFORE_A_COUNT);
}

export function titleOf(what: { title: string | null; people?: readonly Somebody[] }, me: string): string {
  const chosen = chosenTitle(what.title);
  if (chosen) return chosen;
  const derived = derivedTitle(what.people ?? [], me);
  return derived || say("chat.unnamed");
}
